import React from 'react'
import { Typography, Button, Box } from '@mui/material'
import styled from '@emotion/styled'
import { colors } from '../../../tokens/colors'
import { FullWidth } from '../Misc/FullWidth'

type Props = {
  assetDetails: {
    note: string
    buttonText: string
    hashedPortalId: string
  }
  assetId: number
  colorTheme: string
  backgroundColor?: string
  storyId: string
  host: string
  onClick?: () => void
}

export const DonationBlockPublic = ({
  assetDetails,
  colorTheme,
  backgroundColor,
  storyId,
  host,
  assetId,
  onClick,
}: Props): JSX.Element => {
  const themeColor = colorTheme || undefined
  let donationParams = `donate?${
    assetDetails.hashedPortalId ? `id=${assetDetails.hashedPortalId}&` : ''
  }`
  donationParams += storyId ? `storyId=${storyId}` : ''

  const appHost = host.includes('staging')
    ? 'staging-nonprofit.resilia.com'
    : 'nonprofit.resilia.com'

  const donationUrl = host.includes('localhost')
    ? `http://localhost:3001/${donationParams}`
    : `https://${appHost}/${donationParams}`

  if (!donationUrl || assetDetails.buttonText === null) {
    return <span />
  }

  const referrerPolicy = host.includes('localhost')
    ? 'no-referrer-when-downgrade'
    : 'strict-origin-when-cross-origin'

  return (
    <FullWidth backgroundColor={backgroundColor}>
      <Container>
        <PreviewNote>{assetDetails.note}</PreviewNote>
        <a
          href={donationUrl}
          id={`public-donation-button-${assetId}`}
          referrerPolicy={referrerPolicy}
        >
          <PreviewButton
            variant='contained'
            style={{ backgroundColor: themeColor }}
            onClick={onClick}
          >
            {assetDetails.buttonText}
          </PreviewButton>
        </a>
      </Container>
    </FullWidth>
  )
}

const Container = styled(Box)`
  text-align: center;
  & a {
    display: inline-block;
    text-decoration: none;
    max-width: 100%;
  }
  & a:active {
    text-decoration: none;
  }
  & a:visited {
    text-decoration: none;
  }
`

const PreviewNote = styled(Typography)`
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-size: 22px;
  text-align: center;
  margin-bottom: 18px;
`

const PreviewButton = styled(Button)`
  max-width: 100%;
  width: 301px;
  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 18px;
  color: white;
  display: block;
  margin: 0 auto;
  background-color: #47855c;
  text-transform: none;
  &:hover {
    background-color: ${colors.customization.shadeForestGreen};
  }
`
